import { render, staticRenderFns } from "./RegistrationData.vue?vue&type=template&id=dc3a3834&"
import script from "./RegistrationData.vue?vue&type=script&lang=js&"
export * from "./RegistrationData.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports